import { NewDiscountPromocode } from "../../../types/Promocodes";

export function isValidPromocode(promo: NewDiscountPromocode): boolean {
  const amount = promo.discount.amount;
  const percentage = promo.discount.percentage;

  const hasValidDiscount =
    (typeof amount === "number" && !percentage) ||
    (typeof percentage === "number" && !amount);

  const hasCombinationsOrSubscriptions =
    (Array.isArray(promo.selectionCombinations) &&
      promo.selectionCombinations.length > 0) ||
    (Array.isArray(promo.subscriptions) && promo.subscriptions.length > 0);

  return Boolean(hasValidDiscount && hasCombinationsOrSubscriptions);
}
